import gql from 'graphql-tag';

export const RETURN_VISIT_MUTATION = gql`
  mutation returnVisit($enrollmentId: ID!) {
    returnVisit(enrollmentId: $enrollmentId) {
      id
    }
  }
`;



// WEBPACK FOOTER //
// ./src/mutations/returnVisit.ts